import React, { FC } from 'react'
import { cn, isOdd } from 'shared/utils'
import { Link } from 'react-router-dom'
import { findEntryOfSource } from 'shared/utils/charts'

import { IChartItemProps } from './ChartItem.props'
import { ConditionRender } from 'components'

const ChartItem: FC<IChartItemProps> = ({ index, factSource, row, columnsLength, assignedСampaigns }) => {

  const entry = findEntryOfSource(row.entries, factSource)

  if (!entry)
    return (
      <div
        className={cn('charts__item', {
          'charts__item--grey': isOdd(index)
        })}
      />
    )

  const hasProduct = entry?.campaign_id && entry?.product_id
  const hasAccess = assignedСampaigns ? assignedСampaigns.includes(`${entry?.campaign_id}`) : true

  return (
    <div
      className={cn(`charts__item charts__item--${columnsLength}`, {
        'charts__item--grey': isOdd(index),
        'charts__item--with-product': hasProduct && hasAccess
      })}
    >
      <ConditionRender
        condition={!!hasProduct && !!hasAccess}
        component={
          <Link
            className="charts__item-content"
            to={{
              pathname: '/projects/' + entry?.campaign_id,
            }}
            state={{ activeProductId: entry?.product_id }}
          >
            <b className="charts__item-title">{entry?.artist}</b>
            <div className="charts__item-subtitle">{entry?.title}</div>
          </Link>
        }
        secondComponent={
          <div className="charts__item-content">
            <b className="charts__item-title">{entry?.artist}</b>
            <div className="charts__item-subtitle">{entry?.title}</div>
          </div>
        }
      />
    </div>
  )
}

export default ChartItem
